<template>
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.902458 5.43355C0.902458 5.43355 7.41276 2.69152 9.67064 1.72599C10.5362 1.33981 13.4715 0.103916 13.4715 0.103916C13.4715 0.103916 14.8262 -0.436739 14.7133 0.876335C14.6757 1.41704 14.3746 3.30942 14.0736 5.35632C13.622 8.25287 13.1328 11.4197 13.1328 11.4197C13.1328 11.4197 13.0575 12.308 12.4178 12.4625C11.7781 12.617 10.7243 11.9218 10.5362 11.7673C10.3856 11.6515 7.7138 9.91353 6.73538 9.06388C6.47195 8.83217 6.17091 8.36875 6.77298 7.82804C8.12775 6.55356 9.7459 4.97013 10.7243 3.96601C11.1759 3.50253 11.6275 2.42117 9.7459 3.73424C7.07407 5.62667 4.43985 7.40322 4.43985 7.40322C4.43985 7.40322 3.83772 7.7894 2.70878 7.44181C1.57979 7.09427 0.262677 6.6308 0.262677 6.6308C0.262677 6.6308 -0.640432 6.0515 0.902458 5.43355Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "IconTG",
};
</script>

<style scoped></style>
